import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "Find_Near_By_Clients",
  class: "d-flex flex-grow-1"
}
const _hoisted_2 = { class: "w-25 ps-2 pt-2 bg-white d-flex flex-column position-relative" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mb-1 pe-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold m-0" }, "Employee Proximity", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ai-line" }, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "pe-2" }
const _hoisted_7 = { class: "row my-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 pe-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-control border-0 text-dark" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Search")
  ])
], -1 /* HOISTED */)
const _hoisted_9 = { class: "col-8 ps-0" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "row my-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 pe-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-control border-0 text-dark" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Distance")
  ])
], -1 /* HOISTED */)
const _hoisted_13 = { class: "col-8 ps-0" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<option value=\"5\">5 miles</option><option value=\"10\">10 miles</option><option value=\"15\">15 miles</option><option value=\"20\">20 miles</option><option value=\"25\">25 miles</option>", 5)
const _hoisted_20 = [
  _hoisted_15
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "d-flex align-items-center justify-content-between w-100" }
const _hoisted_23 = { class: "fw-bold text-break" }
const _hoisted_24 = ["id"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h icon-size" }, null, -1 /* HOISTED */)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["aria-labelledby"]
const _hoisted_28 = ["id", "onClick"]
const _hoisted_29 = { class: "d-flex align-items-center gap-2" }
const _hoisted_30 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile text-primary me-1" }, null, -1 /* HOISTED */)
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker text-primary me-1" }, null, -1 /* HOISTED */)
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "d-flex flex-wrap align-items-center mb-1" }
const _hoisted_38 = { class: "text-muted fw-bold" }
const _hoisted_39 = {
  class: "text-center py-2",
  ref: "trigger"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw fa-2x" }, null, -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", null, "Loading...", -1 /* HOISTED */)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  key: 0,
  class: "text-center py-2"
}
const _hoisted_44 = {
  key: 1,
  class: "nearby-emp-list pe-1"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow-1",
  id: "NearbyClient__VisitMap"
}, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPill = _resolveComponent("ProductPill")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn text-primary fw-bold p-0 me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearNearbyClientFilters()))
          }, "Clear"),
          _createElementVNode("button", {
            class: "btn text-primary fw-bold p-0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeNearbyClientPanel()))
          }, "Done")
        ])
      ]),
      _hoisted_5,
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Search by Name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nearbyClientSearchTerm) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.nearbyClientSearchTerm]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nearbyClientDistance) = $event))
              }, _hoisted_20, 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.nearbyClientDistance]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(`nearby-emp-list pe-1 ${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nearbyClientPanelList, (clientPanel) => {
          return (_openBlock(), _createElementBlock("div", {
            key: clientPanel.PatientDetails.Id,
            class: _normalizeClass(`nearby-emp-card mb-2 ${_ctx.selectedNearbyClient.Id === clientPanel.PatientDetails.Id ? 'selected' : ''}`),
            onClick: ($event: any) => (_ctx.highlightClientPin(clientPanel.PatientDetails, clientPanel.PatientDetails.Id))
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(clientPanel.PatientDetails.LastName) + " " + _toDisplayString(clientPanel.PatientDetails.FirstName), 1 /* TEXT */),
              _createElementVNode("button", {
                type: "button",
                class: "btn px-1 py-0 ms-1 btn-outline-primary icon-size align-self-start",
                "data-bs-toggle": "dropdown",
                id: `client__actions${clientPanel.PatientDetails.Id}`
              }, _hoisted_26, 8 /* PROPS */, _hoisted_24),
              _createElementVNode("div", {
                class: "dropdown-menu",
                "aria-labelledby": `client__Actions${clientPanel.PatientDetails.Id}`
              }, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  id: `add-task-${clientPanel.PatientDetails.Id}`,
                  href: "javascript:void(0);",
                  onClick: ($event: any) => (_ctx.scheduleVisit(clientPanel.PatientDetails))
                }, " Add Task ", 8 /* PROPS */, _hoisted_28)
              ], 8 /* PROPS */, _hoisted_27)
            ]),
            _createElementVNode("div", _hoisted_29, [
              (clientPanel.PatientDetails?.PhoneNumber)
                ? (_openBlock(), _createElementBlock("small", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("a", {
                      href: 'tel:' + clientPanel.PatientDetails?.PhoneNumber
                    }, _toDisplayString(_ctx.formatPhone(clientPanel.PatientDetails?.PhoneNumber)), 9 /* TEXT, PROPS */, _hoisted_32)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("small", _hoisted_33, _toDisplayString(clientPanel.PatientDetails.Distance) + " miles away", 1 /* TEXT */)
            ]),
            (clientPanel.PatientDetails?.AddressLine1 || clientPanel.PatientDetails?.AddressLine2)
              ? (_openBlock(), _createElementBlock("small", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("address", _hoisted_36, _toDisplayString(clientPanel.PatientDetails?.AddressLine1) + " " + _toDisplayString(clientPanel.PatientDetails?.AddressLine2), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_ProductPill, {
                class: "me-2",
                "product-id": _ctx.getApplicationId(clientPanel.PatientDetails.Application)
              }, null, 8 /* PROPS */, ["product-id"]),
              _createElementVNode("div", {
                class: _normalizeClass(`me-2 pill text-capitalize ${_ctx.getStatusPillClass(clientPanel.PatientDetails.Status).toLowerCase()}`)
              }, _toDisplayString(_ctx.getStatusText(clientPanel.PatientDetails.Status)), 3 /* TEXT, CLASS */),
              _createElementVNode("small", _hoisted_38, _toDisplayString(clientPanel.PatientDetails.AgencyName), 1 /* TEXT */)
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_21))
        }), 128 /* KEYED_FRAGMENT */)),
        _withDirectives(_createElementVNode("div", _hoisted_39, _hoisted_42, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.pageCount < _ctx.totalPageCount && _ctx.showLoading]
        ]),
        (_ctx.pageCount >= _ctx.totalPageCount && _ctx.nearbyClientPanelList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Showing " + _toDisplayString(_ctx.totalItemCount) + " Patients ", 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (!_ctx.nearbyClientPanelList.length && !_ctx.showLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, " No patients found "))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createCommentVNode(" Premium will come later "),
      _createCommentVNode(" <div class=\"d-flex justify-content-end\">\r\n                <img class=\"pe-2\" src=\"../../../../../../img/Axxess_Intelligence_logo_2.svg\" alt=\"\" />\r\n                <button class=\"ai-premium-btn mx-2 mt-2 mb-1\">Premium</button>\r\n            </div>\r\n            <div class=\"ai-line\"></div> ")
    ]),
    _hoisted_45
  ]))
}